import { IStoreState } from "../../../../reducers/types";
import {
  getIsTravelApp,
} from "../../reducer";
import { connect, ConnectedProps } from "react-redux";
import { HertzLoyaltyWorkflow } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    isTravelApp: getIsTravelApp(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HertzLoyaltyWorkflowConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedHertzLoyaltyWorkflow = connector(HertzLoyaltyWorkflow);
